import React from 'react';
import {useParams} from 'react-router-dom';
import {useGetSAMMeetingQuery, useListSAMTasksQuery} from "../../apis/samApi";
import TaskTable from "../../components/tables/TaskTable";
import {useUserProfileQuery} from "../../apis/authenticationApi";
const SAMAgendaTaskTable = ({isCurrent}) => {
    const { meeting } = useParams();
    const {data: tasks, isFetching} = useListSAMTasksQuery();
    const {data: samMeeting, isFetching: isFetchingMeeting} = useGetSAMMeetingQuery(meeting);
    const {data: userProfile} = useUserProfileQuery();
    

    return (
        <TaskTable tasks={(tasks || []).filter(task => (isCurrent && samMeeting?.id !== task.parent &&
            (task.taskStatus === 'ToDo' || task.taskStatus === 'Accepted' || task.taskStatus === 'Doing' || task.completed > (samMeeting?.scheduledStartTimestamp - (7 * 24 * 60 * 60 * 1000)))) ||
            (!isCurrent && samMeeting?.id === task.parent))}
                loading={isFetching && isFetchingMeeting}
                showCompleteDefaultStatus={true}
                hideShowCompletedFilter={true}
                showPrivacyColumn={true}
                editTaskEndpoint={!isCurrent? `/company-admin/shared-action-meetings/edit-agenda/${meeting}/task` : undefined}
                newSubTaskEndpoint={!isCurrent? `/company-admin/shared-action-meetings/edit-agenda/${meeting}/task/new/parent-task` : undefined}
                newTaskEndpoint={(!isCurrent && userProfile?.company?.role === "CompanyOwner")? `/company-admin/shared-action-meetings/edit-agenda/${meeting}/task/new` : undefined}
        />
    )
}

export default SAMAgendaTaskTable;
